<div class="container">
  <div class="input">
    <mat-slide-toggle [checked]="selectedValue" [(ngModel)]="selectedValue">{{message}}</mat-slide-toggle>
  </div>

  <div class="buttons">
    <button
      mat-raised-button color="primary"
      class="submit-button"
      [disabled]=""
      (click)="save()">{{'COMMON.SAVE'|translate}}
    </button>

    <button
      mat-raised-button color="default"
      (click)="cancel()">{{'COMMON.CANCEL'|translate}}
    </button>
  </div>
</div>
